<template>
  <slices-block v-if="entry" :entries="[entry]" />
</template>

<script>
import { queryEntryCTF } from '../../../plugins/contentful'
import SlicesBlock from '@/components/slices/slices-block'

export default {
  name: 'CtfRichTextEmbedEntry',
  components: {
    SlicesBlock
  },
  props: {
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      entry: null
    }
  },
  async created () {
    this.entry = await queryEntryCTF(this.sysId)
  }
}
</script>
